module.exports = __webpack_public_path__ + "img/generic.b9b395a0.svg";